import { render, staticRenderFns } from "./personImages.vue?vue&type=template&id=3272fbf2&scoped=true&"
import script from "./personImages.vue?vue&type=script&lang=js&"
export * from "./personImages.vue?vue&type=script&lang=js&"
import style0 from "./personImages.vue?vue&type=style&index=0&id=3272fbf2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3272fbf2",
  null
  
)

export default component.exports